import * as yup from 'yup';


export const projectFormValidationSchema = yup.object().shape({
  name: yup.string().defined().required(),
  description:  yup.string().optional(),
  dueDate: yup.date().optional()
    .nullable()
    .transform(v => (v instanceof Date && !isNaN(v as any) ? v : null)),

}, [])

export interface ProjectFormForm {
  name: string
  description: string
  dueDate: Date

}

